module.exports = __webpack_public_path__ + "static/media/twitter.c228a51f.png";